module.exports = "<app-search [query]=\"query\" [data]=\"data\" [cart]=\"cart\" [disable]=\"disable\"></app-search>"